<template>
  <div class="login_page">
    <div class="login_select" v-if="isZhixiLogin === false">
      <div class="login_title" v-if="!isSuccess">授权门店登录软件</div>
      <div class="form_van" v-if="!isSuccess && !isfail">
        <van-field
          readonly
          clickable
          name="picker"
          :value="value"
          label=""
          :default-index="defaultIndex"
          placeholder="请选择要登录的门店"
          @click="showPicker = true"
          class="field_store"
        />
      </div>
      <van-button v-if="!isSuccess && !isfail" type="info" class="field_store_ok" @click="handlerOk"> 登录 </van-button>
      <div class="success_block" v-if="isSuccess">
        <van-icon name="success" color="#fff" size="50" />
        <div class="success_text">登录成功！</div>
      </div>
      <div class="success_block" v-if="isfail">
        <van-icon name="cross" color="red" size="50" />
        <div class="fail_text">登录失败！</div>
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
      <div class="mask"></div>
    </div>
    <div class="zhixi_login" v-else>
      <div class="zhixi_login_block" v-if="!zhixiLoginSuccess && !zhixiLoginFail">
        <div class="zhixi_title">智洗后台</div>
        <van-button type="default" plain class="auth_btn" @click="handlerZhixiLogin">授权登录</van-button>
      </div>
      <div class="success_block" v-if="zhixiLoginSuccess">
        <van-icon name="success" color="#fff" size="48" />
        <div class="result_title">登录成功</div>
      </div>
      <div class="fail_block" v-if="zhixiLoginFail">
        <van-icon name="cross" color="#f56c6c" size="48" />
        <div class="result_title fail">登录失败</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Axios from 'axios';
  import { Toast } from 'vant';
  export default {
    data() {
      return {
        value: '',
        storelist: [],
        columns: [],
        defaultIndex: '',
        showPicker: false,
        authObj: {
          code: '',
          state: '',
        },
        res: {},
        isSuccess: false,
        isfail: false,
        isLoading: false,
        isZhixiLogin: '',
        zhixiLoginSuccess: false,
        zhixiLoginFail: false,
      };
    },
    methods: {
      //门店登录
      async handlerOk() {
        if (JSON.stringify(this.res) === '{}' || !this.value) {
          return Toast.fail('请选择门店！');
        }
        const stores = { ...this.res?.data.data, default_select_store: '' };
        this.storelist.forEach(item => {
          if (item.store_name === this.value) {
            stores.default_select_store = item.store_id;
          }
        });
        try {
          this.isLoading = true;
          await Axios.post('https://backend.skzhixi.com/washkit/mhg/wechat/login/confirm', {
            state: this.authObj.state,
            stores: stores,
            code: this.authObj.code,
          });
          this.isSuccess = true;
          this.isLoading = false;
        } catch (error) {
          this.isfail = true;
          this.isLoading = false;
        }
      },
      exitToWeChat() {
        if (typeof WeixinJSBridge !== 'undefined') {
          WeixinJSBridge.call('closeWindow'); // eslint-disable-line no-undef
          WeixinJSBridge.call('closeWindow'); // eslint-disable-line no-undef
        } else {
          document.addEventListener(
            'WeixinJSBridgeReady',
            () => {
              WeixinJSBridge.call('closeWindow'); // eslint-disable-line no-undef
            },
            false
          );
        }
        // 5秒后仍未关闭，提示用户手动操作
        setTimeout(() => {
          alert('请点击右上角"…"选择关闭返回微信');
        }, 5000);
      },
      // 后台登录
      async handlerZhixiLogin() {
        try {
          this.isLoading = true;
          await Axios.post('https://backend.skzhixi.com/manage/open/v1/admin/login/confirm', {
            state: this.authObj.state,
            code: this.authObj.code,
          });
          this.zhixiLoginSuccess = true;
          this.isLoading = false;
          this.exitToWeChat();
        } catch (error) {
          this.zhixiLoginFail = true;
          this.isLoading = false;
        }
      },
      onConfirm(value) {
        this.value = value;
        this.showPicker = false;
      },
      getLoginInfo() {
        let url = 'https://backend.skzhixi.com/washkit/mhg/wechat/login/callback';
        return Axios.post(url, this.authObj);
      },
    },
    async mounted() {
      const code = this.$route.query.code || '';
      const state = this.$route.query.state || '';
      const flag = state.includes('ZHIXILOGIN_');
      // console.error(flag, state, code);
      if (code && state && !flag) {
        // 门店登录
        this.authObj.code = code;
        this.authObj.state = state;
        this.isZhixiLogin = false;
        try {
          const storeRes = await this.getLoginInfo();
          this.res = storeRes;
          let storelist = storeRes?.data?.data?.store_select_list || [];
          let defaultStoreId = storeRes?.data?.data?.default_select_store || '';
          this.storelist = storelist;
          // 下拉选项
          this.columns = storelist.map((item, index) => {
            // 默认
            if (defaultStoreId === item.store_id) {
              this.defaultIndex = index;
              this.value = item.store_name;
            }
            return item.store_name;
          });
        } catch (error) {
          const errMsg = error.response.data.msg || error.message || '获取门店失败！';

          return Toast.fail(errMsg);
          // return Toast.fail('获取门店失败！');
        }
      }
      if (code && state && flag) {
        // 后台
        this.authObj.code = code;
        this.authObj.state = state;
        this.isZhixiLogin = true;
      }
    },
  };
</script>

<style scoped lang="scss">
  .login_page {
    width: 100%;
    height: 100%;
    .login_select {
      background-image: url(../assets/banner_login.jpg);
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .login_title {
        margin-top: 90px;
        color: #fff;
      }
      .form_van {
        margin-top: 100px;
        width: 100%;
        .field_store {
          width: 80%;
          margin: 0 auto;
          border-radius: 4px;
        }
      }
      .field_store_ok {
        margin-top: 80px;
        width: 30%;
        background: #fff;
        border-color: #fff;
        color: #3961cd;
        border-radius: 4px;
        font-size: 16px;
      }
      .success_block {
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 100px;
        .success_text {
          font-size: 24px;
        }
        .fail_text {
          color: red;
        }
      }
      .zhixi_login_block {
        display: flex;
        flex-direction: column;
        align-items: center;
        .field_store_ok {
          margin-top: 80px;
          width: 30%;
          background: #fff;
          border-color: #fff;
          color: #3961cd;
          border-radius: 4px;
          font-size: 16px;
        }
      }
    }
    .zhixi_login {
      background-image: url(../assets/banner_login.jpg);
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .zhixi_login_block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        .zhixi_title {
          font-size: 22px;
          color: #fff;
          margin-top: -100px;
          margin-bottom: 100px;
        }
        .auth_btn {
          width: 200px;
          height: 44px;
          background: #fff;
          border: none;
          border-radius: 22px;
          color: #3961cd;
          font-size: 16px;
          font-weight: 500;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
          &:active {
            transform: scale(0.98);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          }
        }
      }
      .success_block,
      .fail_block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        .result_icon {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          &.success {
            background: rgba(70, 184, 70, 0.25);
            border: 3px solid rgba(70, 184, 70, 0.5);
          }
          &.fail {
            background: rgba(245, 108, 108, 0.25);
            border: 3px solid rgba(245, 108, 108, 0.5);
          }
        }
        .result_title {
          font-size: 24px;
          color: #fff;
          font-weight: 500;
          margin-bottom: 10px;
          &.fail {
            color: #f56c6c;
          }
        }
      }
    }
  }
</style>
